// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2cLcD","bigColWidth":"Table_bigColWidth__39ufJ","biggerColWidth":"Table_biggerColWidth__1Kfbm","row":"Table_row__3VNzm","col":"Table_col__8RQQJ"};